import { combineReducers } from "redux";

import store from "./_store";
import store_list from "./_stores";
import fetching from "./_fetching";

export default combineReducers({ store, store_list, fetching });
